import { Modal } from "antd";
import Loader from "../ui/Loader";

export default function FullScreenLoading() {
  return (
    <Modal open footer={null} closeIcon={null} className="full-screen-loading">
      <Loader />
    </Modal>
  );
}
